var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"primary",attrs:{"icon":"","text":"","dark":"","to":_vm.to},on:{"click":function($event){return _vm.$emit('click')}}},[_c('v-icon',{domProps:{"textContent":_vm._s('add')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }